import { ArticleNavigationSwiper } from './libs/swiper';

document.addEventListener('DOMContentLoaded', function () {
  const articleNavigationSwiper = new ArticleNavigationSwiper(
    '.js-swiper-anav'
  );
});
